import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const includes = ['Recetas profesionales con pasos numerados y temperaturas exactas', 'Tabla de problemas y soluciones para cada producto', 'Costos reales calculados con insumos argentinos actualizados', 'Precios sugeridos con margen mínimo del 200%', 'Checklists de producción imprimibles', 'Sistema de producción en tanda para maximizar el rendimiento por hora', 'Estrategia de venta específica para cada producto', '100% pensado para horno convencional de gas en cocina doméstica argentina'];
export function TomoIncludes() {
  return <section className="py-12 px-4 max-w-4xl mx-auto" data-id="element-307">
      <div className="bg-cream-dark/20 rounded-3xl p-8 md:p-12 border border-cream-dark pt-[5px] pb-[5px]" data-id="element-308">
        <h3 className="text-2xl font-bold text-center mb-8 font-serif" data-id="element-309">
          Cada Tomo Incluye:
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-310">
          {includes.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="flex items-start gap-3 bg-white p-4 rounded-xl shadow-sm" data-id="element-311">
              <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-312" />
              <span className="text-sm text-carbon-lighter leading-snug" data-id="element-313">
                {item}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}